'use client';

import { useRef } from 'react';

import { NewsLetterService } from '@/services/modules/NewsletterService';

export default function useNewsLetterService() {
  const ref = useRef<NewsLetterService | null>(null);
  if (ref.current === null) {
    ref.current = new NewsLetterService();
  }
  return ref.current;
}
